import { palette } from './system/palette';

export const brand = {
  brand: palette['blue-500'],
  'brand.light': palette['blue-80'],
  'brand.ai': palette['plum-500'],
  'brand.ai.light': palette['plum-80'],
  'brand.onboarding': palette['yellow-300'],
};
